// extracted by mini-css-extract-plugin
export default {"fitInfoContainer":"RI2VV","fitInfoLabel":"FrIS2","fitInfoBar":"rRc2z","icon":"JeSkM"};